import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export function supportedLocales () {
  return {
    en: 'English',
    sl: 'Slovenščina'
  }
}

export function supportedLocalesInclude (locale) {
  return Object.keys(supportedLocales()).includes(locale)
}

export function getBrowserLocale (options = {}) {
  const defaultOptions = {countryCodeOnly: false}

  const opt = {
    ...defaultOptions,
    ...options
  }

  const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language

  if (!navigatorLocale) {
    return undefined
  }

  const trimmedLocale = opt.countryCodeOnly ? navigatorLocale.trim().split(/-|_/)[0] : navigatorLocale.trim()

  return trimmedLocale
}

export function getSupportedLocales () {
  let annotatedLocales = []
  for (const code of Object.keys(supportedLocales())) {
    annotatedLocales.push({
      code,
      name: supportedLocales()[code]
    })
  }

  return annotatedLocales
}

function loadLocaleMessages () {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function getStartingLocale () {
  if(window.appState.lang) {
    return window.appState.lang
  }

  if (document.documentElement.lang) {
    return document.documentElement.lang
  }

  const browserLocale = getBrowserLocale({countryCodeOnly: true})

  if (supportedLocalesInclude(browserLocale)) {
    return browserLocale
  }
  return process.env.VUE_APP_I18N_LOCALE || 'sl'
}

export function setDocumentLanguage (locale) {
  document.documentElement.lang = locale
}

export default new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'sl',
  messages: loadLocaleMessages(),
  pluralizationRules: {
    /**
     * @param choice {number} a choice index given by the input to $tc`
     * @param choicesLength {number} an overall amount of available choices
     * @returns a final choice index to select plural word by
     */
    'sl': function (choice, choicesLength) {
      // this === VueI18n instance, so the locale property also exists here

      if (choice === 0) {
        return 0
      }

      if (choice === 1) {
        return 1
      }

      if (choice === 2) {
        return 2
      }

      if (choice >= 3 && choice <= 4) {
        return (choicesLength === 5) ? 3 : 2
      }

      return (choicesLength >= 5) ? 4 : 3
    }
  }
})



// WEBPACK FOOTER //
// ./src/i18n.js